export const validateAddressBody = (addressType, inputType, value) => {
    let label  = addressType === "pickUpLocation" ? "Pick Up Location" : addressType === "dropOffLocation" ? "Drop off Location" : "Additional stop"
    if (inputType === 'address' ) {
        if(!validateAddress(value[0],value[1])) {
            return {validationStatus: false, errorMessage: `Invalid Pickup address for ${label}. Please select valid address from the dropdown`}
        }
    }

    if (inputType === 'floor' ) {
        if(!validateNotEmpty(value)) {
            return {validationStatus: false, errorMessage: `Invalid Floor for ${label}`}
        }
    }

    if (inputType === 'unitNumber' ) {
        if(!validateNotEmpty(value)) {
            return {validationStatus: false, errorMessage: `Invalid Unit Number for ${label}`}
        }
    }

    if (inputType === 'contactName' ) {

        if(!validateNotEmpty(value)) {
            return {validationStatus: false, errorMessage: `Invalid Contact Name for ${label}`}
        }
    }

    if (inputType === 'contactNumber' ) {

        if(!validatePhoneNumber(value)) {
            return {validationStatus: false, errorMessage: `Invalid Phone Number for ${label}`}
        }
    }

    return {validationStatus: true, errorMessage: ""}

}


export const validateAddress = (lat , lng) => {
    if(!lat || !lng) {
        return false
    }
    if(typeof(lat) !== 'number' || typeof(lng) !== 'number' ) {
        return false
    }
    return true
}


export const validateNotEmpty = (data) => {
    if (!data) {
        return false
    }
    return true
}

export const validatePhoneNumber = (phone) => {
    if(phone.length !== 8){
        return false;
    }else if (!['8','9'].includes(phone.substring(0,1))){
        return false;
    }else if(!phone.match(/^[0-9]+$/)){
        return false
    }
    return true;
}